<template>
<div class="container py-5" style="min-height:600px">
    <div v-if="loading" class="d-flex flex-row justify-content-center loading_card" style="height:600px;align-items: center;">
            <div v-if="loading" class="loading_card_spinner">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3"
                    color="var(--primary-color)" />
            </div>
        </div>
<div v-else class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
    <!-- Repeat this card for each product -->
    <!-- يمكنك تكرار هذا العنصر مع تغيير التفاصيل حسب الحاجة -->
   <product
          v-for="(item, index) in products"
          :key="index"
          v-bind="item"
          :name="item.name"
                :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer" :unit="item.unit"
                :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount" :qnt="item.qnt"
                :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note" :range_price="item.range_price"
        />
    </div>
    <!-- بقية المنتجات ... (نفس التنسيق) -->
    <!-- يمكنك تكرار البطاقات حسب الحاجة -->
      <div class="col-lg-12 text-center">
      <nav aria-label="Page navigation example"  class="paginate_div">
        <b-pagination
          v-if="products && products.length !== 0"
          v-model="page"
          :total-rows="count"
          :per-page="paginate"
          :prev-text="$t('prev')"
          :next-text="$t('next')"
          pills
          size="sm"
  class="paginate_theme13"
            @change="handlePageChange"
        />
      </nav>
    </div>
    
  </div>
</template>
<script>
import product from "../components/one_product.vue";
import { HollowDotsSpinner } from "epic-spinners";

export default {
  components: { product, HollowDotsSpinner },
  data() {
    return {
      show_list: false,
      show_grid: true,
      loading: false,
      products: [],
      total: 0,
      page: 1,
      count: 0,
      paginate: 12,
      sort: 'id',
      order: 'desc',
      categories: [],
      category_id: null,
      brands_array: [],
      options_array: [],
      name: null,
    };
  },
  created() {
    this.loadData();
      this.$store.state.showHeader = true;
        this.$store.state.showFooter = true;
  },
  methods: {
    loadData() {
      this.loading = true;
      this.axios.get(`${this.$store.state.base_api_url}${this.$store.storeName}/theme13/section/${this.$route.params.id}`, {
        headers: { "Accept-Language": this.$i18n.locale }
      }).then((res) => {
        const data = res.data.data;
        this.name = data.name;
        this.categories = data.categories;
      }).finally(() => {
        this.loading = false;
      });

      this.axios.post(`${this.$store.state.base_api_url}${this.$store.storeName}/products/filter_product_theme_5`, {
        section_id: this.$route.params.id,
        category: this.category_id,
        options: this.options_array,
        sort: this.sort,
        order: this.order,
        paginate: this.paginate,
        brands: this.brands_array
      }, {
        headers: { "Accept-Language": this.$i18n.locale }
      }).then(res => {
        this.products = res.data.data.products;
        this.count = res.data.meta.total;
        this.total = res.data.meta.total;
      });
    },
     loadDataCategory() {

      this.axios.post(`${this.$store.state.base_api_url}${this.$store.storeName}/products/filter_product_theme_5`, {
        section_id: this.$route.params.id,
        category: this.category_id,
        options: this.options_array,
        sort: this.sort,
        order: this.order,
        paginate: this.paginate,
        brands: this.brands_array
      }, {
        headers: { "Accept-Language": this.$i18n.locale }
      }).then(res => {
        this.products = res.data.data.products;
        this.count = res.data.meta.total;
        this.total = res.data.meta.total;
      });
    },
    upadatesort(event) {
      const [order, sort] = event.target.value.split("/");
      this.order = order;
      this.sort = sort;
      this.loadDataCategory();
    },
    filter_category(id, index) {
      this.category_id = id;
      this.loadDataCategory();
    },
    handlePageChange(val) {
      this.page = val;
      this.loadData();
    }
  },
    watch: {
    langChange() {
        this.loadData();


    },
    "$route.params": {
      handler(newValue) {
        this.loadData();
       

      },
      immediate: true
    }
  },
  updated() {
    this.langChange = this.$i18n.locale

  },
};
</script>
